<template>
	<div class="pay-container">
		<div class="pay-content" v-if="!loading">
			<div class="pay-info">
				<img :src="pay.goods && pay.goods[0] ? pay.goods[0].thumb : ''" v-if="order_type==1" class="pay-thumb">
				<img src="@/assets/payok.png" v-else class="pay-thumb">
				<div class="pay-price">
					<span class="price-symbol">￥</span>
					<span class="price-value">{{pay.price || "0.00"}}</span>
				</div>
				<div class="pay-title">{{pay.title}}</div>
			</div>
			<div class="pay-method">
				<div v-for="(item, index) in pay.list" :key="index" class="pay-method-item" v-if="item.status==1">
					<el-radio v-model="paytype" :label="item.paytype+''">
						<div class="pay-method-content">
							<img :src="item.icon" class="pay-icon">
							<div class="pay-method-info">
								<div class="pay-method-title">{{item.title}}</div>
								<div v-if="item.paytype==2" class="pay-method-desc">
									可用{{base.texts && base.texts.balance ? base.texts.balance : '余额'}}
									<span class="pay-balance">{{user.balance || "0.00"}}</span>
								</div>
								<div v-if="item.paytype==3" class="pay-method-desc">
									可用{{fenxiao.texts && fenxiao.texts.predeposit ? fenxiao.texts.predeposit : '预存款'}}
									<span class="pay-balance">￥{{user.deposit_money || "0.00"}}</span>
								</div>
							</div>
						</div>
					</el-radio>
				</div>
				<div  class="pay-method-item">
					<el-radio v-model="paytype" label="-999">
						<div class="pay-method-content">
							<img src="@/assets/weixin.png" class="pay-icon">
							<div class="pay-method-info">
								<div class="pay-method-title">微信支付</div>
							</div>
						</div>
					</el-radio>
				</div>
			</div>
			<div class="pay-action">
				<el-button type="primary" @click="onPay" :style="'background-color: '+base.btn_color+';border-color: '+base.btn_color+';'" class="pay-button">确认支付</el-button>
			</div>
		</div>
		
		<!-- 支付密码弹窗 -->
		<el-dialog
			title="请输入支付密码"
			:visible.sync="payPasswordVisible"
			width="400px"
			center
			:close-on-click-modal="false"
			:show-close="false"
		>
			<div class="password-input">
				<el-input
					v-model="payPassword"
					type="password"
					placeholder="请输入支付密码"
					maxlength="6"
					show-password
				></el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onCancelPassword">取消</el-button>
				<el-button type="primary" @click="onConfirmPassword" :style="'background-color: '+base.btn_color+';border-color: '+base.btn_color+';'">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'

	export default {
		name: 'Pay',
		data() {
			return {
				paytype: '',
				order_no: '',
				order_type: '',
				order: {},
				pay: {},
				pay_data: null,
				is_submit: false,
				loading: true,
				payPasswordVisible: false,
				payPassword: ''
			}
		},
		computed: {
			...mapGetters(['base', 'fenxiao', 'is_login', 'user'])
		},
		created() {
			this.order_no = this.$route.query.order_no;
			this.order_type = this.$route.query.order_type;
			
			this.init();
		},
		mounted() {
			this.getUser();
		},
		methods: {
			...mapActions(['getUser']),
			onCancelPassword() {
				this.payPasswordVisible = false;
				this.payPassword = '';
			},
			onConfirmPassword() {
				this.payPasswordVisible = false;
				this.onPayWithPassword();
			},
			onPay() {
				if (!this.paytype) {
					return this.$message.error("请选择支付方式");
				}
				console.log(this.paytype);
				if(this.paytype == -999){
					this.$message.info('未配置微信支付');
					return;
				}
				if ((this.paytype == 2 || this.paytype == 3) && this.base.is_pay_password == 1) {
					if (this.user.is_pay_password != 1) {
						this.$message.error("请先设置支付密码");
						this.$router.push('/user/payPassword');
						return;
					}
					this.payPasswordVisible = true;
					return;
				}
				
				this.startPayment();
			},
			onPayWithPassword() {
				const data = {
					order_no: this.order_no,
					order_type: this.order_type,
					paytype: this.paytype,
					pay_password: this.payPassword
				};
				
				this.$api.pay(data).then(res => {
					if (res.code == 1) {
						this.payComplete();
					} else {
						this.$message.error(res.message || "支付失败");
					}
				}).catch(err => {
					this.$message.error(err.message || "支付失败");
				});
				
				// 清空密码
				this.payPassword = '';
			},
			startPayment() {
				if (this.pay_data && this.paytype == 1) {
					this.wxPay();
				} else {
					const data = {
						order_no: this.order_no,
						order_type: this.order_type,
						paytype: this.paytype
					};
					
					this.$api.pay(data).then(res => {
						if (res.code == 1) {
							if (this.paytype == 1) {
								this.pay_data = res.data;
								this.wxPay();
							} else {
								this.payComplete();
							}
						} else {
							this.$message.error(res.message || "支付失败");
						}
					}).catch(err => {
						this.$message.error(err.message || "支付失败");
					});
				}
			},
			wxPay() {
				// PC端微信支付通常是展示二维码
				if (this.pay_data && this.pay_data.code_url) {
					// 弹出二维码窗口，用户扫码支付
					this.$alert('请扫描二维码进行支付', '微信支付', {
						dangerouslyUseHTMLString: true,
						confirmButtonText: '支付完成',
						center: true,
						callback: () => {
							this.checkPayStatus();
						}
					});
				} else if (this.pay_data && this.pay_data.mweb_url) {
					// 打开新窗口进行支付
					window.open(this.pay_data.mweb_url, '_blank');
					this.$alert('请在新打开的窗口中完成支付', '微信支付', {
						confirmButtonText: '支付完成',
						callback: () => {
							this.checkPayStatus();
						}
					});
				} else {
					this.$message.error("获取支付信息失败");
				}
			},
			checkPayStatus() {
				// 查询支付状态
				this.$api.getPayOrder({
					order_no: this.order_no,
					order_type: this.order_type
				}).then(res => {
					if (res.code == 1 && res.data.status == 1) {
						this.payComplete();
					} else {
						this.$message.error(res.message);
					}
				}).catch(() => {
					this.$message.error("查询支付状态失败");
				});
			},
			payComplete() {
				this.$message.success("支付成功！");
				
				// 根据订单类型跳转到不同页面
				if (this.order_type == 1) {
					this.$router.push('/myorderlistview');
				} else if (this.order_type == 2 || this.order_type == 3 || this.order_type == 4 || this.order_type == 5) {
					this.$router.go(-1);
				} else if (this.order_type == 6) {
					console.log('订单支付成功');
					this.$router.push('/myorderlistview');
				}
			},
			init() {
				this.$api.getPayOrder({
					order_no: this.order_no,
					order_type: this.order_type
				}).then(res => {
					if (res.code == 1) {
						this.loading = false;
						this.pay = res.data;
					} else {
						this.$message.error(res.message || "获取订单信息失败");
						this.$router.go(-1);
					}
				}).catch(err => {
					this.$message.error(err.message || "获取订单信息失败");
					this.$router.go(-1);
				});
			},
			changePay(e) {
				this.paytype = e;
				
				if (this.paytype == 2 && this.base.is_pay_password == 1 && this.user.is_pay_password != 1) {
					this.$message.error("请先设置支付密码");
					this.$router.push('/user/payPassword');
				}
			}
		}
	}
</script>

<style lang="less" scoped>
.pay-container {
	padding: 30px;
	background-color: #f5f5f5;
	
	padding-top: 150px;
}

.pay-content {
	max-width: 800px;
	margin: 0 auto;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	padding: 30px;
}

.pay-info {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-bottom: 30px;
	padding-bottom: 30px;
	border-bottom: 1px solid #eee;
}

.pay-thumb {
	width: 100px;
	height: 100px;
	object-fit: cover;
	margin-bottom: 20px;
}

.pay-price {
	margin-top: 15px;
	display: flex;
	align-items: flex-end;
}

.price-symbol {
	font-size: 16px;
	font-weight: bold;
	color: #333;
	margin-bottom: 5px;
}

.price-value {
	font-size: 30px;
	font-weight: bold;
	color: #333;
}

.pay-title {
	margin-top: 10px;
	color: #666;
	font-size: 14px;
}

.pay-method {
	margin-bottom: 30px;
}
:deep(.el-radio){
	display: flex
;
    align-items: center;
}
.pay-method-item {
	padding: 15px 0;
	border-bottom: 1px solid #eee;
}

.pay-method-content {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.pay-icon {
	width: 30px;
	height: 30px;
	margin-right: 15px;
}

.pay-method-info {
	flex: 1;
}

.pay-method-title {
	font-size: 16px;
	color: #333;
	font-weight: bold;
}

.pay-method-desc {
	font-size: 12px;
	color: #666;
	margin-top: 5px;
}

.pay-balance {
	color: #3c9c8f;
	font-weight: bold;
}

.pay-action {
	display: flex;
	justify-content: center;
	margin-top: 30px;
}

.pay-button {
	width: 200px;
	height: 45px;
	font-size: 16px;
}

.password-input {
	padding: 20px 0;
}
</style>
